import { render, staticRenderFns } from "./CompCard.vue?vue&type=template&id=036ae0b7&scoped=true"
import script from "./CompCard.vue?vue&type=script&lang=js"
export * from "./CompCard.vue?vue&type=script&lang=js"
import style0 from "./CompCard.vue?vue&type=style&index=0&id=036ae0b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ae0b7",
  null
  
)

export default component.exports